import { EmailDef } from "@components/smart/GeneralFieldDefinition";
import BindingContext from "@odata/BindingContext";
import { IDefinition, IGetDefinition } from "@pages/PageUtils";
import i18next from "i18next";

import { IFormDef } from "../../../views/formView/Form";
import FormView from "../../../views/formView/FormView";

export const sendToEmployeeMailPath = BindingContext.localContext("invitationMail");

export const getDefinitions: IGetDefinition = (): IDefinition => {
    const form: IFormDef = {
        id: `SendInvitationSpecialForm`,
        summary: [],
        translationFiles: getDefinitions.translationFiles,
        formControl: FormView,
        fieldDefinition: {
            [sendToEmployeeMailPath]: {
                label: i18next.t("Employee:Form.InvitationMailLabel"),
                isRequired: true,
                ...EmailDef,
                useForValidation: true
            },
        },
        groups: [{
            id: "main",
            rows: [[{ id: sendToEmployeeMailPath }]]
        }]
    };


    return {
        form
    };
};

getDefinitions.translationFiles = ["Employee", "Common"];
